module.exports = __webpack_public_path__ + "i18n/en_d886c997599cee5e9fbd11a532e7ef81.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/m_en.properties
// module id = A5Ct
// module chunks = 55